import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=operation&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '经营提升',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `在酒店经营过程中，许多业主面临入住率低迷、成本居高不下或客户满意度下滑等棘手问题，这些问题往往源自市场定位不清、运营流程冗杂或团队执行脱节。华美通过全链路诊断与精准干预，帮助酒店突破增长瓶颈。重新校准目标客群与价格策略，优化运营流程，同时植入动态绩效机制，激发团队潜能。`,
        icons: [
            {
                name: '经营提升',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/10.经营提升.pdf'),
                path: "四库赋能-酒店资管/经营提升/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店资管/经营提升/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/经营提升/数据赋能'),
                path: "四库赋能-酒店资管/经营提升/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/经营提升/全球案例/全球案例（经营提升）.xlsx'),
                path: "四库赋能-酒店资管/经营提升/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店资管/经营提升/预警问题/预警问题（经营提升）.xlsx'),
                path: "四库赋能-酒店资管/经营提升/预警问题"
            },
        ]
    }]
}